import gql from 'graphql-tag'

import { ExternalSchoolFieldsFragment } from 'main/gql/externalSchool'
import { UserFieldsFragment, UserWithFamilyFieldsFragment } from 'main/gql/user'

export const REQUEST_INFO_MODAL_QUERY = gql`
  query RequestInfoModal($id: Int!) {
    externalSchool(id: $id) {
      ...ExternalSchoolFields
    }
    user {
      ...UserFields
      ...UserWithFamilyFields
    }
  }

  ${ExternalSchoolFieldsFragment}
  ${UserFieldsFragment}
  ${UserWithFamilyFieldsFragment}
`
